import { render, staticRenderFns } from "./RegistryCaseSideBar.vue?vue&type=template&id=345d1de5&"
import script from "./RegistryCaseSideBar.vue?vue&type=script&lang=js&"
export * from "./RegistryCaseSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports